import { BannerCreativeData } from '../typings/bannersEditState';
import { BannerImageForEdit } from '../typings/domain';

export const mapCreativeData = (
    prevCreativeData: BannerCreativeData | undefined,
    curCreative: BannerImageForEdit
): BannerCreativeData => ({
    ...prevCreativeData,
    id: curCreative.id || '',
    name: curCreative.name || '',
    previewUrl: curCreative.url || '',
    width: curCreative.width || 0,
    height: curCreative.height || 0,
    type: curCreative.creativeType,
    isAdaptive: Boolean(curCreative.isAdaptive),
    isImage: Boolean(curCreative.isImage)
});
